import React from "react";
import { DataTable } from "./DataTable";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { useCceModel } from "../cceModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { useCceDetailModel } from "./details/cceDetailModel";

export const DataBox = () => {
    const { selectedRowKeys, exportCce, disableCce } = useCceModel(({ selectedRowKeys, searchParam }) => [selectedRowKeys, searchParam]);
    const { updateFormVal } = useCceDetailModel(() => [])
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let cceEditKey = "10-1-2";
        let isFindNav = findNav(cceEditKey);
        if (!isFindNav) {
            addNav(cceEditKey, { id: selectedRowKeys[0], mode: "edit" });
            updateFormVal("edit", null);
        } else {
            globalPrompt("modal", {
                title: "信用证跳转详情",
                type: "warning",
                text: "您还有信用证详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(cceEditKey, { id: selectedRowKeys[0], mode: "edit" });
                    updateFormVal("edit", null);
                }
            })
        }
    }

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.L_A_AD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => addNav("10-1-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.L_A_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.L_A_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportCce()}
            >导出</Button>
        </YhAuth>
        {/* <YhAuth resCode={ResourceAuthEnum.I_DEL}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        message.warning("请选择你要作废的单据");
                        return;
                    }
                    globalPrompt("modal", {
                        title: "信用证单作废",
                        text: ` `,
                        onOk: () => disableCce(selectedRowKeys[0]),
                    })
                }}
            >作废</Button>
        </YhAuth> */}
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}